import { exhaustiveCheck } from '@interxfi/utilities/types/exhaustive';
import type { ScheduleName } from './helpers';

export function getScheduleNameFromSlug(slug: unknown): ScheduleName {
  switch (slug) {
    case 'trading':
    case 'transfers':
      return slug;
    case 'money-market':
    case 'moneyMarket':
      return 'moneyMarket';
    default:
      return 'trading';
  }
}

export function getScheduleSlugFromName(scheduleName: ScheduleName) {
  switch (scheduleName) {
    case 'trading':
      return 'trading';
    case 'transfers':
      return 'transfers';
    case 'moneyMarket':
      return 'money-market';
    default:
      exhaustiveCheck(scheduleName);
      return 'trading';
  }
}

export function getHoursSchedulePath(scheduleName: ScheduleName, version?: string) {
  const params = new URLSearchParams();
  if (version) {
    params.set('version', version);
  }

  return `/hours/schedule/${getScheduleSlugFromName(scheduleName)}${params.size ? `?${params.toString()}` : ''}`;
}
